module.exports = __webpack_public_path__ + "static/media/hpz840@2x.96dc7212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/workstation/hpz840@2x.png
// module id = 318
// module chunks = 0